import { Outlet, useRouterState } from '@tanstack/react-router';
import { ThemeToggle } from '@buildbee/ui';
import { Logo } from './Logo';

/**
 * Client-portal frame. Inside a workspace portal (`/portal/<slug>/...`) the portal module renders
 * the contractor's own branded header, so this frame stays bare; the BuildBee header only shows on
 * the portal picker (`/portal`), where no contractor is known yet.
 */
export function PortalLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const branded = /^\/portal\/[^/]+/.test(pathname);
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      {branded ? (
        <div className="flex justify-end px-4 pt-3 sm:px-6">
          <ThemeToggle />
        </div>
      ) : (
        <header className="sticky top-0 z-30 flex h-14 items-center justify-between bg-background/75 px-4 backdrop-blur-xl sm:px-6">
          <span className="inline-flex items-center gap-2.5 text-[15px] font-semibold tracking-[-0.01em]">
            <Logo className="size-7" /> Client portal
          </span>
          <ThemeToggle />
        </header>
      )}
      <main className="mx-auto w-full max-w-5xl flex-1 px-4 pb-16 pt-6 sm:px-6">
        <Outlet />
      </main>
      <footer className="flex items-center justify-center gap-1.5 px-4 py-6 text-center text-[12px] text-muted-foreground">
        Powered by <Logo className="size-4" heavy label="" /> BuildBee
      </footer>
    </div>
  );
}
